import * as React from "react";

/**
 * Custom hook that scrolls a target element into view when an item count increases.
 * Used to keep the "Add Shift Block" button visible after adding new shift blocks.
 *
 * @param itemCount - The current count of items (e.g., shift blocks)
 * @param targetRef - Ref to the element to scroll into view (e.g., add button)
 */
export const useScrollToAddButton = (
    itemCount: number,
    targetRef: React.RefObject<HTMLElement | null>
): void => {
    const previousCountRef = React.useRef<number>(itemCount);

    React.useEffect(() => {
        const currentCount = itemCount;
        const previousCount = previousCountRef.current;

        // When items are added (count increases), scroll the target into view
        if (currentCount > previousCount && targetRef.current) {
            // Use requestAnimationFrame to ensure the DOM has updated before scrolling
            requestAnimationFrame(() => {
                targetRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
            });
        }

        // Update the previous count for the next comparison
        previousCountRef.current = currentCount;
    }, [itemCount, targetRef]);
};
